<template>
  <div class="p-3 card mb-3">
    <label class="titlePage">Cidades de Provas Relacionadas a Configuração</label>

    <fccTable
      striped
      hover
      responsive
      search
      pagination
      :fields="fields"
      :items="items"
      :porPage="itemsPorPage"
      :key="componentKey"
      @row-selected="selecionaLinha"
    />

    <div class="text-right mb-3">
      <fccButton @click="importar" :disabled="dadosSelecionados.length <= 0">Importar</fccButton>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import fccStore from '../../../../../store'

export default {
  data() {
    return {
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: false
        },
        { key: 'data', label: 'Data de Aplicação', sortable: true },
        { key: 'cidade', label: 'Cidade de Provas', sortable: true },
        { key: 'tipohorario', label: 'Tipo de Horário', sortable: true },
        { key: 'importado', label: 'Importado', sortable: true }
      ],
      items: [],
      itemsPorPage: 10,
      dadosSelecionados: [],
      componentKey: 0
    }
  },
  created() {
    this.listarCidadesDeProvasRelacionadasAConfiguracao()
  },
  watch: {
    configuracao() {
      this.listarCidadesDeProvasRelacionadasAConfiguracao()
    }
  },
  computed: {
    configuracao() {
      return fccStore.state.localDeProva.configuracao
    },
    status() {
      return fccStore.state.localDeProva.listaStatus
    }
  },
  methods: {
    forceRender() {
      this.componentKey += 1
    },
    selecionaLinha(dados) {
      this.dadosSelecionados = dados
    },
    leftPad(number, width, pad = '0') {
      return number.toString().padStart(width, pad)
    },
    importar() {
      const payload = this.dadosSelecionados.map((item) => {
        return {
          ...item,
          cdFuncionario: this.dadosUserSession.usuCdFuncionario
        }
      })

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          fccStore.state.baseUrlLocalDeProva + `LocalExameCidade/InserirLocalExameCidade`,
          payload,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.$emit('importado')
          this.forceRender()
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarCidadesDeProvasRelacionadasAConfiguracao() {
      axios
        .get(
          fccStore.state.baseUrlLocalDeProva +
            `LocalExameCidade/GetLocalExameCidade/${this.configuracao.idlocalconfig}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.items = response.data.map((item) => ({
            ...item,
            cidade: this.leftPad(item.codcidexame, 3) + ' - ' + item.cidade
          }))
        })
        .catch(this.setErrorSystem)
    }
  }
}
</script>
